import type { PropsWithChildren } from 'react';

import styles from './ageGateFormContainer.module.css';

export const AgeGateFormContainer = ({ children }: PropsWithChildren) => (
  <div className={styles['container']}>{children}</div>
);
